import createItemsDuck from '@esentai/core/ducks/items';

import api from '../api';
import { getItemsRoot } from '../utils';

export default createItemsDuck('purchase_history', {
  api,
  getRoot: getItemsRoot,
});
